var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"map-svg",staticClass:"map-svg",attrs:{"viewBox":"0 0 960 600","preserveAspectRatio":"xMidYMid meet"}})}
var staticRenderFns = []

export { render, staticRenderFns }